export default "/images/b5294e9eb570e885587f0b28ce135552.avif";